/**
 * HOME
 */

/* Carousel */
(function($) {

	// メインビジュアル
	if ( $('#js-hero-carousel')[0] ) {
		$('#js-hero-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false
		});
	}

	// 商品一覧
	if ( $('#js-products-detail')[0] ) {
		$('#js-products-detail').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			adaptiveHeight: false,
			asNavFor: '#js-products-thumb',
			responsive: [
				{
					breakpoint: 640,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		});
	}
	if ( $('#js-products-thumb')[0] ) {
		$('#js-products-thumb').slick({
			infinite: true,
			slidesToShow: 7,
			slidesToScroll: 1,
			arrows: false,
			centerMode: true,
			focusOnSelect: true,
			asNavFor: '#js-products-detail',
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 5
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						centerMode: false,
						variableWidth: false,
						centerPadding: '6%'
					}
				},
				{
					breakpoint: 360,
					settings: {
						slidesToShow: 3,
						centerMode: true,
						variableWidth: false,
						centerPadding: '6%'
					}
				}
			]
		});
	}

	// STORY
	if ( $('#js-story-carousel-1')[0] ) {
		$('#js-story-carousel-1').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 5000,
			asNavFor: '#js-story-carousel-2'
		});
	}
	if ( $('#js-story-carousel-2')[0] ) {
		$('#js-story-carousel-2').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 5000,
			asNavFor: '#js-story-carousel-1'
		});
	}

	// RECIPE
	if ( $('#js-recipe-carousel')[0] ) {
		$('#js-recipe-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						centerMode: true,
						centerPadding: '6%'
					}
				}
			]
		});
	}


})(jQuery);